import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=0561663c&"
import script from "./Comments.vue?vue&type=script&lang=js&"
export * from "./Comments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports